// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bic_a bic_x bic_j bic_u bic_bc bic_ql bic_vv"};